var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import './ButtonStyles.scss';
/**
 * Button Component
 * @version 1.1.0
 * @since 2026-01-19
 */
export const Button = forwardRef((_a, ref) => {
    var _b;
    var { variant = 'default', mode = 'light', className = '', isMenu = false, children } = _a, props = __rest(_a, ["variant", "mode", "className", "isMenu", "children"]);
    const baseClass = 'qmb-ui-button';
    const variantClass = variant !== 'default' ? `${baseClass}--${variant}` : '';
    const modeClass = mode === 'dark' ? `${baseClass}--dark` : '';
    const menuClass = isMenu ? `${baseClass}--menu` : '';
    const combinedClass = [baseClass, variantClass, modeClass, menuClass, className].filter(Boolean).join(' ');
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    React.createElement("button", Object.assign({ ref: ref, type: (_b = props.type) !== null && _b !== void 0 ? _b : 'button', className: combinedClass }, props), children));
});
Button.displayName = 'Button';
